/* Akel Beauty — one-click accessory add-ons for the cart drawer. */

(function () {
  'use strict';

  function setButtonLabel(button, label) {
    var node = button.querySelector('[data-upsell-button-label]');
    if (node) node.textContent = label;
  }

  function showError(root, message) {
    var node = root && root.querySelector('[data-cart-upsell-error]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  function announce(message) {
    var node = document.querySelector('[data-cart-upsell-status]');
    if (!node) return;
    node.textContent = '';
    window.setTimeout(function () {
      node.textContent = message || '';
    }, 20);
  }

  function updateHeaderCount(cart) {
    if (!cart) return;
    document.querySelectorAll('.cart-count').forEach(function (node) {
      node.textContent = cart.item_count;
    });
  }

  function fetchCart() {
    return fetch(window.Akel.routes.cart_url + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function addAccessory(button) {
    if (button.disabled || button.getAttribute('aria-busy') === 'true') return;

    var root = button.closest('[data-cart-upsells]');
    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId || !root || !window.Akel || !window.Akel.routes) return;

    var defaultLabel = button.getAttribute('data-default-label') || '';
    var addingLabel = button.getAttribute('data-adding-label') || defaultLabel;
    var addedLabel = button.getAttribute('data-added-label') || defaultLabel;
    var addedMessage = button.getAttribute('data-added-message') || addedLabel;
    var upsellIndex = parseInt(button.getAttribute('data-upsell-index'), 10);
    if (Number.isNaN(upsellIndex)) upsellIndex = 0;
    var addSucceeded = false;

    showError(root, '');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setButtonLabel(button, addingLabel);

    fetch(window.Akel.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        addSucceeded = true;
        return response.json();
      })
      .then(function () {
        setButtonLabel(button, addedLabel);
        announce(addedMessage);

        return fetchCart().then(function (cart) {
          updateHeaderCount(cart);
          document.dispatchEvent(
            new CustomEvent('akel:cart:upsell-added', {
              detail: { cart: cart, upsellIndex: upsellIndex }
            })
          );
        });
      })
      .catch(function () {
        if (addSucceeded) {
          window.location.href = window.Akel.routes.cart_url;
          return;
        }
        button.disabled = false;
        button.setAttribute('aria-busy', 'false');
        setButtonLabel(button, defaultLabel);
        showError(root, window.Akel.strings.cartError);
      });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;
    event.preventDefault();
    addAccessory(button);
  });
})();
